// ══════════════════════════════════════════════════════════════════════
//  TITLES ZA IYANNA FOUNDATION
//  Title ni ya KUDUMU. Ikishapatikana hairudi nyuma hata rating ikishuka.
//  Ndio maana inaheshimika — inaelezea ulichowahi kufanya, si ulipo leo.
//
//  Vigezo vyote viko hapa mahali pamoja. Ukitaka kuvibadilisha kesho,
//  unabadilisha hapa tu — na mabadiliko yanaonekana kwenye ukurasa wa
//  uwazi mara moja, ili kila mtu ajue kanuni mpya.
// ══════════════════════════════════════════════════════════════════════

export const PLAYER_TITLES = [
  {
    code: 'BM',
    name: 'Bingwa Mkuu',
    english: 'Grand Master (Iyanna)',
    rating: 2200,
    norms: 3,
    normPerformance: 2250,
    color: '#B45309',
    description: 'Kiwango cha juu kabisa. Norm tatu za performance 2250+ na rating 2200.',
  },
  {
    code: 'BF',
    name: 'Bingwa wa Foundation',
    english: 'Master',
    rating: 2000,
    norms: 2,
    normPerformance: 2050,
    color: '#7C3AED',
    description: 'Norm mbili za performance 2050+ na rating 2000.',
  },
  {
    code: 'BC',
    name: 'Bingwa Chipukizi',
    english: 'Candidate Master',
    rating: 1800,
    norms: 1,
    normPerformance: 1850,
    color: '#2563EB',
    description: 'Norm moja ya performance 1850+ na rating 1800.',
  },
  {
    code: 'MK',
    name: 'Mchezaji Kinara',
    english: 'Expert',
    rating: 1600,
    norms: 1,
    normPerformance: 1650,
    color: '#0891B2',
    description: 'Norm moja ya performance 1650+ na rating 1600.',
  },
  {
    code: 'MJ',
    name: 'Mchezaji Jasiri',
    english: 'Club Player',
    rating: 1400,
    norms: 0,
    normPerformance: 0,
    color: '#059669',
    description: 'Rating 1400 iliyochapishwa. Hakuna norm inayohitajika.',
  },
  {
    code: 'MR',
    name: 'Mchezaji Rasmi',
    english: 'Rated Player',
    rating: 1000,
    norms: 0,
    normPerformance: 0,
    color: '#6B7280',
    description: 'Title ya kwanza — unaipata siku rating yako ya kwanza inapochapishwa.',
  },
];

export function titleByCode(code) {
  return PLAYER_TITLES.find(t => t.code === code) || null;
}

// Title ya juu kabisa ambayo mchezaji anastahili SASA
export function qualifiesFor(rating, normsCount) {
  if (!rating) return null;
  return PLAYER_TITLES.find(t => rating >= t.rating && normsCount >= t.norms) || null;
}

// Title haipotei: tunachukua ya juu kati ya aliyonayo na anayostahili sasa
export function higherTitle(currentCode, candidateCode) {
  if (!candidateCode) return currentCode || null;
  if (!currentCode) return candidateCode;
  const iCur = PLAYER_TITLES.findIndex(t => t.code === currentCode);
  const iNew = PLAYER_TITLES.findIndex(t => t.code === candidateCode);
  if (iCur === -1) return candidateCode;
  if (iNew === -1) return currentCode;
  return iNew < iCur ? candidateCode : currentCode; // index ndogo = title kubwa
}

// ══════════════════════════════════════════════════════════════════════
//  IFC — IYANNA FOUNDATION COACH INDEX
//  Kocha hachezi, hivyo Elo haifai. Badala yake tunapima kile
//  kinachoonekana: wanafunzi wangapi amewafikisha kwenye rating rasmi,
//  wamepanda kiasi gani chini yake, wangapi wamepata title, amefundisha
//  session ngapi na mahudhurio yalikuwaje.
//
//  Uzito wa kila kipengele unachapishwa hadharani. Hakuna kificho.
// ══════════════════════════════════════════════════════════════════════

export const IFC_BASE = 1000;
export const IFC_CAP = 2500;

export const IFC_WEIGHTS = [
  {
    key: 'studentsRated',
    label: 'Wanafunzi wenye rating rasmi',
    unit: 'kila mwanafunzi',
    points: 4,
    max: 200,
    note: 'Kufikisha mwanafunzi kwenye rating rasmi ni kazi ya msingi ya kocha.',
  },
  {
    key: 'avgRatingGain',
    label: 'Wastani wa ongezeko la rating za wanafunzi (miezi 12)',
    unit: 'kila pointi ya wastani',
    points: 3,
    max: 300,
    note: 'Hiki ndicho kipimo kikuu — kocha bora hupandisha wanafunzi wake.',
  },
  {
    key: 'titledStudents',
    label: 'Wanafunzi waliopata title',
    unit: 'kila mwanafunzi',
    points: 40,
    max: 400,
    note: 'Title ya mwanafunzi ni ushahidi wa kudumu wa ufundishaji bora.',
  },
  {
    key: 'sessions',
    label: 'Session alizofundisha',
    unit: 'kila session',
    points: 1.5,
    max: 300,
    note: 'Inachukuliwa moja kwa moja kutoka ripoti za session zilizothibitishwa.',
  },
  {
    key: 'attendanceRate',
    label: 'Kiwango cha mahudhurio kwenye session zake',
    unit: 'kila asilimia',
    points: 1.5,
    max: 150,
    note: 'Kocha anayewafanya wanafunzi warudi ni kocha mzuri.',
  },
  {
    key: 'certifications',
    label: 'Mafunzo/vyeti alivyopata',
    unit: 'kila cheti',
    points: 50,
    max: 150,
    note: 'Kujiendeleza mwenyewe.',
  },
  {
    key: 'yearsActive',
    label: 'Miaka ya utumishi',
    unit: 'kila mwaka',
    points: 20,
    max: 100,
    note: 'Uzoefu wa muda mrefu.',
  },
];

export function computeIFC(inputs = {}) {
  const parts = IFC_WEIGHTS.map(w => {
    const raw = Number(inputs[w.key]) || 0;
    const earned = Math.min(w.max, Math.round(raw * w.points));
    return { ...w, raw, earned };
  });
  const total = parts.reduce((a, p) => a + p.earned, 0);
  return {
    parts,
    earned: total,
    ifc: Math.min(IFC_CAP, IFC_BASE + total),
  };
}

export const COACH_TITLES = [
  {
    code: 'KMK',
    name: 'Kocha Mkuu',
    english: 'Senior Trainer',
    ifc: 2100,
    require: { titledStudents: 6, sessions: 250 },
    color: '#B45309',
    description: 'IFC 2100+, wanafunzi 6 wenye title, session 250+.',
  },
  {
    code: 'KT',
    name: 'Kocha wa Taifa',
    english: 'National Trainer',
    ifc: 1800,
    require: { titledStudents: 3, sessions: 150 },
    color: '#7C3AED',
    description: 'IFC 1800+, wanafunzi 3 wenye title, session 150+.',
  },
  {
    code: 'KC',
    name: 'Kocha wa Club',
    english: 'Club Trainer',
    ifc: 1500,
    require: { studentsRated: 10, sessions: 60 },
    color: '#2563EB',
    description: 'IFC 1500+, wanafunzi 10 wenye rating, session 60+.',
  },
  {
    code: 'KM',
    name: 'Kocha Mwanzilishi',
    english: 'Instructor',
    ifc: 1200,
    require: { sessions: 20, certifications: 1 },
    color: '#059669',
    description: 'IFC 1200+, session 20+, cheti 1.',
  },
];

export function coachTitleFor(ifc, inputs = {}) {
  return COACH_TITLES.find(t => {
    if (ifc < t.ifc) return false;
    return Object.entries(t.require).every(([k, v]) => (Number(inputs[k]) || 0) >= v);
  }) || null;
}

export function higherCoachTitle(currentCode, candidateCode) {
  if (!candidateCode) return currentCode || null;
  if (!currentCode) return candidateCode;
  const i1 = COACH_TITLES.findIndex(t => t.code === currentCode);
  const i2 = COACH_TITLES.findIndex(t => t.code === candidateCode);
  if (i1 === -1) return candidateCode;
  if (i2 === -1) return currentCode;
  return i2 < i1 ? candidateCode : currentCode;
}
